import Vue from 'vue';
import ElementUI from 'element-ui';
import qxUI from '@qxintech/qx-ui';
import { qxMath, qxUtils, qxComponent, qxLodop } from '@qxintech/qx-component';
import Nzh from 'nzh';
import './plugins/axios';
import NP from 'number-precision';
import FileUploadList from 'Components/common/FileUploadList';
import validate from './plugins/validate';
import CONSTANT from './constant/constant';
import App from './App.vue';
import router from './router';
import store from './store/store';
import './styles.scss';
import './assets/icon/iconfont.css';
import './assets/iconfont/iconfont.css';
import './assets/tsiconfont/tsiconfont.css';
import Search from './components/common/search/Search';
import QxFormItem from './components/order/QxFormItem';
import autoComplete from './components/common/autoComplete';
import dialog from './components/dialog';
import CustomerForm from './components/order/CustomerForm';
import SaleOrderCustForm from './components/order/SaleOrder/SaleOrderCustForm';
import SelectUnit from './components/order/SaleOrder/SelectUnit';
import UserForm from './components/order/UserForm';
import OrderFactory from './plugins/OrderFactory';
import QxNewFormItem from './components/order/QxNewFormItem';
import CityChoose from "Components/order/CityChoose";
import i18n from './i18n/index';
import tsUtils from './plugins/tsUtils';
import TsSearch from './components/common/tsSearch/TsSearch.vue';
import TsTable from './components/common/TsTable.vue';
import TableFilterPopover from "./components/order/TableFilterPopover";
import FormSkeleton from './components/order/FormSkeleton.vue';

const setUserUrl = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const urlObj = {};
  user.permissions.forEach(e => {
    urlObj[e.perms] = e.checked;
  });
  window.location.userPermissions = urlObj;
};


Vue.use(ElementUI);
Vue.use(qxUI);
Vue.use(qxComponent);
Vue.use(autoComplete);
Vue.use(dialog);
Vue.use(OrderFactory);
Vue.use(i18n);
Vue.use(tsUtils);

router.beforeEach((to, from, next) => {
  const component = to.path.split('/')[1];
  if (!(component.includes('check') && component.split('-')[0] === 'check')) {
    store.commit('tab/addTab', { component, routerInfo: to });
  }
  next();
});
Vue.prototype.math = qxMath;
Vue.prototype.utils = qxUtils;
Vue.prototype.nzh = Nzh.cn;
Vue.prototype.lodop = qxLodop;
Vue.prototype.CONSTANT = CONSTANT;
Vue.prototype.validate = validate;
Vue.prototype.NP = NP;
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
Vue.component('Search', Search);
Vue.component('TsSearch', TsSearch);
Vue.component('TsTable', TsTable);
Vue.component('TableFilterPopover', TableFilterPopover);
Vue.component('QxFormItem', QxFormItem);
Vue.component('QxNewFormItem', QxNewFormItem);
Vue.component('CustomerForm', CustomerForm);
Vue.component('SaleOrderCustForm', SaleOrderCustForm);
Vue.component('SelectUnit', SelectUnit);
Vue.component('UserForm', UserForm);
Vue.component('FileUploadList', FileUploadList);
Vue.component('CityChoose', CityChoose);
Vue.component('FormSkeleton', FormSkeleton);
Vue.directive('url-check', {
  // 暂时关闭check

  inserted(el, val) {
    if (val.value === '') {
      return;
    }
    // 不管怎么样性能都贼差，就这样吧
    if (window.location.userPermissions) {
      setUserUrl();
    }
    const permissions = window.location.userPermissions;
    if (!permissions[val.value]) {
      el.remove();
    }
  }
});
Vue.directive('url-disabled', {
  inserted(el, val) {
    if (val.value === '') {
      return;
    }
    // 不管怎么样性能都贼差，就这样吧
    if (window.location.userPermissions) {
      setUserUrl();
    }
    const permissions = window.location.userPermissions;
    if (!permissions[val.value]) {
      el.disabled = true;
      el.classList.add('is-disabled');
    }
  }
});
